import React from 'react';
import { secondsToMilliseconds } from 'date-fns';
import JSConfetti from 'js-confetti';
import { useTimer } from './useTimer';

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const CONFETTI_DURATION_MS = secondsToMilliseconds(5);

export function useReleasePartyConfetti({ mintStartTimestamp }: { mintStartTimestamp: number }) {
  const [confetti, setConfetti] = React.useState<JSConfetti | undefined>();

  const confettiEndTimestamp = mintStartTimestamp + CONFETTI_DURATION_MS;

  useTimer({
    expiryTimestamp: confettiEndTimestamp,
  });

  const now = Date.now();

  const isBeforeConfettiEnd = now < confettiEndTimestamp;

  const isAfterMintStartTime = now > mintStartTimestamp;

  const shouldThrowConfetti = isAfterMintStartTime && isBeforeConfettiEnd;

  const isAfterConfettiEnd = now > confettiEndTimestamp;

  const throttleConfetti = React.useCallback(async () => {
    if (!confetti) return;

    for (let i = 0; i < 10; i++) {
      await sleep(100);
      confetti.addConfetti({
        emojis: ['🚀', '🎵'],
      });
    }
  }, [confetti]);

  React.useEffect(() => {
    if (isAfterConfettiEnd) return;

    setConfetti(new JSConfetti());
  }, [isAfterConfettiEnd]);

  // Throw confetti
  React.useEffect(() => {
    if (shouldThrowConfetti) throttleConfetti();
  }, [throttleConfetti, shouldThrowConfetti]);
}
